class VideoAutoplay extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    // Markup that opts into the poster-flash fix starts the video at
    // `opacity-0`; removing the class reveals it. No-op for instances whose
    // markup never sets `opacity-0` (e.g. the engineered-section video).
    const reveal = () => this.video.classList.remove('opacity-0');

    // Opt-in accessibility gate. When `respect-reduced-motion` is set and the
    // visitor's OS asks for reduced motion, don't autoplay: reveal the still
    // poster immediately instead of the animation. Instances without the
    // attribute are unaffected.
    if (
      this.hasAttribute('respect-reduced-motion') &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      reveal();
      this.video.pause();
      return;
    }

    // Reveal only once frames are actually rendering, so the poster never
    // flashes before the animation starts. If autoplay is refused, reveal
    // anyway so the still poster shows rather than an empty box.
    this.video.addEventListener('playing', reveal, { once: true });

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.video.play().catch(reveal);
        } else {
          this.video.pause();
        }
      },
      { threshold: 0.1 },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('video-autoplay')) {
  customElements.define('video-autoplay', VideoAutoplay);
}
